module.exports = __webpack_public_path__ + "img/inv_en.d23d1a8a.png";